// extracted by mini-css-extract-plugin
export default {"drop":"_14jLHU57XFvcXamcqcN1lV","alert":"_2-5JVCicbyHRUkzsOQMxAW"};